import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useForm, { Form } from "../../../../hooks/useForm";
import Controls from "../../../../components/form/controls/Controls";
import {
  createDevice,
  getDeviceDetail,
  updateDevice,
} from "../../../../apis/CMS/device.api";
import { formatMac } from "../../components/Device/Helper";

const initialValue = {
  no: "",
  modelNo: "",
  status: "init",
  palletNo: "",
  cartonNo: "",
  serialNo: "",
  ethMac: "",
  wifiMac: "",
  bluetoothMac: "",
  manufactureDate: "",
  factoryLine: "",
  chipSetId: "",
  storage: "",
  memory: "",
  rcuSn: "",
  fwVersion: "",
  hwVersion: "",
};

const StatusOption = [
  {
    id: "active",
    name: "active",
  },
  {
    id: "init",
    name: "init",
  },
  {
    id: "blocked",
    name: "blocked",
  },
];

const DeviceDetail = () => {
  const { id } = useParams();
  const { values, setValues, handleInputChange, resetForm } =
    useForm(initialValue);

  useEffect(() => {
    if (id) {
      getDeviceDetail(id, (result) => {
        setValues(result);
      });
    }
  }, [id, setValues]);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = {
      ...values,
      mac: formatMac(values.ethMac.toString()),
    };
    if (id) {
      data.id = values.whiteListId;
      updateDevice(values.whiteListId, data, (result) => {
        console.log(result);
      });
    } else {
      createDevice(data, (result) => {
        console.log(result);
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Grid container>
        <Grid item xs={6} p={5}>
          <Controls.Input
            name="no"
            value={values.no}
            label="No. (#)"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="modelNo"
            value={values.modelNo}
            label="Model No."
            type="text"
            onChange={handleInputChange}
          />

          <Controls.Select
            name="status"
            label="Status"
            value={values.status}
            onChange={handleInputChange}
            options={StatusOption}
          />

          <Controls.Input
            name="palletNo"
            value={values.palletNo}
            label="Pallet No."
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="cartonNo"
            value={values.cartonNo}
            label="Carton No."
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="serialNo"
            value={values.serialNo}
            label="Serial No."
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="ethMac"
            value={values.ethMac}
            label="ETH MAC"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="wifiMac"
            value={values.wifiMac}
            label="Wi-Fi MAC"
            type="text"
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={6} p={5}>
          <Controls.Input
            name="bluetoothMac"
            value={values.bluetoothMac}
            label="Bluetooth MAC"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="manufactureDate"
            value={values.manufactureDate}
            label="Manufacture date"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="factoryLine"
            value={values.factoryLine}
            label="Factory/line"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="chipSetId"
            value={values.chipSetId}
            label="Chipset ID"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="storage"
            value={values.storage}
            label="Storage (flash)"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="memory"
            value={values.memory}
            label="Memory (RAM)"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="rcuSn"
            value={values.rcuSn}
            label="RCU S/N"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="fwVersion"
            value={values.fwVersion}
            label="FW Version"
            type="text"
            onChange={handleInputChange}
          />
          <Controls.Input
            name="hwVersion"
            value={values.hwVersion}
            label="HW Version"
            type="text"
            onChange={handleInputChange}
          />
          <div style={{ marginTop: "10px" }}>
            <Controls.Button type="submit" text="Submit" />
            <Controls.Button text="Reset" color="inherit" onClick={resetForm} />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default DeviceDetail;
